import * as web3 from "@solana/web3.js"
import { serialize, deserialize} from './borsh/index.js';
import { assetList, carAsset, ToKenDef, Contract, GameConfig, StatMod, TireAsset, MotorAsset, BatteryAsset, RadarAsset, WeaponAsset, phantomAPP } from "./definitions.js";
import base58_to_binary from './crypto/base58_to_binary.ts';
import binary_to_base58 from './crypto/binary_to_base58.mjs';
import { blake2bHex } from './crypto/blake/blake2b.js';
import * as nacl from "tweetnacl-ts"
import { BACKPACK, BlockchainInfos, PHANTOM, PHANTOMAPP } from "./blockchainSession.ts";
import { BackpackWindow } from "./wallets.js";

    const classes = ['A','B','C'];  

    type attribute ={
        trait_type:string;
        value:string;
    }

    type GameServer = {
        ssl: boolean;
        addr: string;
        port: number;
    }
    
    const CONFIG_SCHEMA ={struct: {repair_time: "u32", steel_per_up : "u32" , per : "f32", nitro_price: "f32" }};
    const CAR_DAMAGE_SCHEMA ={struct: {time: "u32", damage : "u32" }};
    const METADATA_CREATOR_SCHEMA = {   struct : 
        {   
            address: "pubkey", 
            verified: "bool", 
            share: "u8"
        }
    }
    const METADATA_COLLECTION_SCHEMA ={ struct : 
        {
        'verified' : 'bool',
        'key' : 'pubkey'
        }
    };

    export const METADATA_MAIN_SCHEMA = { 
        struct : 
        {    
            key: "u8", 
            updateAuthority : "pubkey",
            mint:"pubkey",
            name: "string", 
            symbol: "string", 
            uri: "string", 
            sellerFeeBasisPoints : "u16",
            toto : "u8",
            creators: { array : {type : METADATA_CREATOR_SCHEMA} },
            primarySaleHappened  : "u8",
            isMutable  : "u8",
            editionNonce  : "u8",
            tokenStandard  : "u32",
            collection  : METADATA_COLLECTION_SCHEMA,

        }
    }


      
      export const METADATA_TIRE_SCHEMA = {
        struct : {
          /// tire mint
          mint: 'pubkey',
          /// class
          class: 'u8',
          /// name of the tire
          name: { array: { type: 'i8' , len: 12}},
          /// mesh object
          tire:  { array: { type: 'i8' , len: 16}},
          /// compression force
          force: 'f32',
          /// shock absorbder stiffness
          stiffness: 'f32',
          /// shock absorbder compression speed
          compression: 'f32',
          /// shock absorbder damping speed
          damping: 'f32',
          /// shock absorbder friction
          friction: 'f32',
          /// tire width
          width: 'f32',
          /// tire radius
          radius: 'f32'

        }
      }
    export const METADATA_MOTOR_SCHEMA = {
        struct : {
          /// tire mint
          mint: 'pubkey',
          ///  motor name
          name: { array: { type: 'i8', len: 12 }}/*,
          /// class
          class: 'u8'
          /// motor power
          power: 'f32',
          /// motor braking
          braking: 'f32' , 
          /// nitro factor
          nitro: 'f32' , 
          /// engine factor a
          a: 'f32' , 
          /// engine factor a
          b: 'f32' , 
          /// engine factor a
          c: 'f32' */

        }
      }
      export const METADATA_BATTERY_SCHEMA = {
            struct : {
                /// tire mint
                mint: 'pubkey',
                /// name of the battery
                name: { array: { type: 'i8' , len: 12}}/*,
                /// class
                class: 'u8',
                /// mesh object
                model:  { array: { type: 'i8' , len: 16}},
                /// total power
                power: 'f32',
                /// total charge
                charge: 'f32'*/
            }
      }

      export const METADATA_RADAR_SCHEMA = {
            struct : {
                /// tire mint
                mint: 'pubkey',
                /// name of the radar
                name: { array: { type: 'i8' , len: 12}}/*,
                /// class
                class: 'u8',
                /// mesh object
                model:  { array: { type: 'i8' , len: 16}},
                /// range
                range: 'f32',
                /// angle
                angle: 'f32',
                /// power
                power: 'f32',*/
            }
        }

        export const METADATA_WEAPON_SCHEMA = {
            struct : {
                /// tire mint
                mint: 'pubkey',
                /// name of the weapon
                name: { array: { type: 'i8' , len: 12}}/*,
                /// class
                class: 'u8',
                /// mesh object
                model:  { array: { type: 'i8' , len: 16}},
                projSpeed: 'f32',
                projMass: 'f32',
                projDelay : 'f32',
                projSize : 'f32',
                power : 'f32',
                durability : 'f32',
                dmg :  'f32',
                blastForce : 'f32',
                blastRadius : 'f32'*/
            }
        }
      
      export const METADATA_CAR_SCHEMA = {
          struct : {
            /// car mint
            mint: 'pubkey',
            /// class
            class: 'u8',
            /// car name
            name: { array: { type: 'i8' , len: 16}},
            /// car object
            chassis: { array: { type: 'i8' , len: 16}},
            /// mass
            massvehicle: 'u32',
            /// max steering
            steeringclamp: 'f32',
            /// steering speed
            steeringincrement: 'f32',
            /// max damage
            maxdmg: 'u32',
            /// suspension length
            suspensionLength: 'f32',
            /// shock absorber
            suspension: METADATA_TIRE_SCHEMA,
            /// motor
            motor: METADATA_MOTOR_SCHEMA,
            /// radar
            battery: METADATA_BATTERY_SCHEMA,
            /// radar
            radar: METADATA_RADAR_SCHEMA,
            /// weapon
            weapon: METADATA_WEAPON_SCHEMA
          }
      }
      
      export const METADATA_GARAGE_SCHEMA = {
        struct : {
          cars: { array: { type: METADATA_CAR_SCHEMA , len: 1}},
          tires: { array: { type: METADATA_TIRE_SCHEMA , len: 1}},
          motors: { array: { type: METADATA_MOTOR_SCHEMA , len: 1}},
          batteries: { array: { type: METADATA_BATTERY_SCHEMA , len: 1}},
          radars: { array: { type: METADATA_RADAR_SCHEMA , len: 1}},
          weapons: { array: { type: METADATA_WEAPON_SCHEMA , len: 1}},
        }
      }


    export const demo_cars = { testnet: ['ALHQTTUeXVaqYuGhs4RmD3fHYmCDs73uVwMe41eGb7r8', '9VK71am93GTvToWwwHLPVzAvfM5FsPKgvcVoS4xYF8F9', 'GcUiefqhTPy1cxG1hqsnihi8R1MmArAuHnHY42cfvv7V' , 'HbicjdBx82pfEGkvN9PQEwezyuryPiRq2crghDycouAJ'], mainnet : []};
    let solanaConnection:web3.Connection | null = null;

    let phantomProvider : any | null = null;
        
    let phantomSession: string | null = null;
    let phantomPk: Uint8Array<ArrayBufferLike>| null = null;
    let sharedSk: Uint8Array<ArrayBufferLike>| null = null;
    let sharedPk: Uint8Array<ArrayBufferLike>| null = null;
    let siteURL: string | null = null;
    

      export type phantomProvider = {
        solana:any;
      }

    export function resetsolana(){
        solanaConnection = null;
      }

    export function initsolana( ep:string) {
        solanaConnection = new web3.Connection(ep);
    }

    export function initPhantom(){

        if(window){
            if ('phantom' in window) {
                const provider:phantomProvider = window.phantom as phantomProvider;

                if (provider?.solana?.isPhantom) {
                    phantomProvider = provider.solana;
                }
            }
        }
    }

    export function readInt(array: Buffer<ArrayBufferLike>) {
        var value = 0;
        for (var i = 0; i < array.length; i++) {
            value = (value * 256) + array[i];
        }
        return value;
    }

    
    async function waitMint(blockchaininfos:BlockchainInfos, mint:string, account:string, func :any){

        if(!solanaConnection)
            return;

        const mk = new web3.PublicKey(mint);
        const uk = new web3.PublicKey(account);
        const tok = getAssociatedTokenAddressSync(mk, uk, false, blockchaininfos.TK);
        if(!tok)
            return;

        const mintAccount = await solanaConnection.getAccountInfo(tok);

        if(mintAccount){
            const amount = mintAccount.data.slice(64, 72).reverse();
            const mintAmount = readInt(amount);
            if(mintAmount === 1)
            {
                func();
                return;
            }
        }

        setTimeout(function (){ waitMint(blockchaininfos, mint, account, func); }, 1000);
    }


    export async function createGarageAccount(blockchaininfos: BlockchainInfos){

        if(!solanaConnection)
            return; 

        if(!blockchaininfos.myAccount)
            return;
        
        const walletKey = new web3.PublicKey(blockchaininfos.myAccount);
        const programId = await new web3.PublicKey(blockchaininfos.mainContract);
        const seed = blockchaininfos.garage_seed;
        const garageKey = await web3.PublicKey.createWithSeed(walletKey, seed , programId);

        const ACC_SIZE = 615;
        const lamports = await solanaConnection.getMinimumBalanceForRentExemption(ACC_SIZE);
    
        const tx = new web3.Transaction().add(
                web3.SystemProgram.createAccountWithSeed({
                    fromPubkey: walletKey, // funder
                    newAccountPubkey: garageKey,
                    lamports: lamports, // 0.1 SOL
                    space: ACC_SIZE,
                    programId: programId,
                    basePubkey: walletKey,
                    seed: seed
                })
        );

        tx.recentBlockhash = (await solanaConnection.getLatestBlockhash('finalized')).blockhash;
        tx.feePayer = walletKey;

        doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos); 
    }

  

    export async function resetGarageSlotSolana(blockchaininfos:BlockchainInfos, cat:string, n:number) {

        if(!solanaConnection)
            return;

        if(!blockchaininfos.myAccount)
            return;

        const pk = new web3.PublicKey(blockchaininfos.myAccount);

        const programId = await new web3.PublicKey(blockchaininfos.mainContract);
        const seed = blockchaininfos.garage_seed;
        const garageKey = await web3.PublicKey.createWithSeed(pk, seed , programId);
        const garageAccount = await solanaConnection.getAccountInfo(garageKey);
        if(garageAccount === null)
            return -1;

        const garageData = doDesera(METADATA_GARAGE_SCHEMA, garageAccount.data);

        if(!garageData)
            return;

        const resetSlotSerBuff = new Uint8Array(3);
        resetSlotSerBuff[0] = 14; //istr

        if(cat === 'tires') {
            if(n>=garageData.tires.length){
                console.log('resetGarageSlot : invalid tire slot');
                return;
            }

            if(garageData.tires[n].name[0] === 0){
                console.log('resetGarageSlot : invalid tire slot');
                return;
            }
            resetSlotSerBuff[1] = n; //slot
            resetSlotSerBuff[2] =  0; //type
        }else if(cat === 'motors') {

            if(n>=garageData.motors.length){
                console.log('resetGarageSlot : invalid motor slot');
                return;
            }

            if(garageData.motors[n].name[0] === 0){
                console.log('resetGarageSlot : invalid motor slot');
                return;
            }

            resetSlotSerBuff[1] = n; //slot
            resetSlotSerBuff[2] = 1; //type
        }else if(cat === 'batteries') {

            if(n>=garageData.batteries.length){
                console.log('resetGarageSlot : invalid batteries slot');
                return;
            }

            if(garageData.batteries[n].name[0] === 0){
                console.log('resetGarageSlot : invalid batteries slot');
                return;
            }

            resetSlotSerBuff[1] = n; //slot
            resetSlotSerBuff[2] = 2; //type
        }else if(cat === 'radars') {

            if(n>=garageData.radars.length){
                console.log('resetGarageSlot : invalid radars slot');
                return;
            }

            if(garageData.radars[n].name[0] === 0){
                console.log('resetGarageSlot : invalid radars slot');
                return;
            }

            resetSlotSerBuff[1] = n; //slot
            resetSlotSerBuff[2] = 3; //type
        }else if(cat === 'weapons') {

            if(n>=garageData.motors.length){
                console.log('resetGarageSlot : invalid weapons slot');
                return;
            }

            if(garageData.motors[n].name[0] === 0){
                console.log('resetGarageSlot : invalid weapons slot');
                return;
            }

            resetSlotSerBuff[1] = n; //slot
            resetSlotSerBuff[2] = 4; //type
        }else if(cat === 'cars') {

            if(n>=garageData.cars.length){
                console.log('resetGarageSlot : invalid car slot');
                return;
            }

            if(garageData.cars[n].name[0] === 0){
                console.log('resetGarageSlot : invalid car slot');
                return;
            }

            resetSlotSerBuff[1] = n; //slot
            resetSlotSerBuff[2] = 5; //type
        }else{
            console.log('invalid category');
            return;
        }

        const gc = new web3.PublicKey(blockchaininfos.mainContract);

        const keys = [ {pubkey: pk, isSigner: true, isWritable: false},
                        {pubkey: garageKey, isSigner: false, isWritable: true}];

        const tx = new web3.Transaction().add(new web3.TransactionInstruction({programId: gc, keys:keys, data: Buffer.from(resetSlotSerBuff.buffer)}));
        tx.feePayer = pk;
        tx.recentBlockhash  = (await solanaConnection.getLatestBlockhash('finalized')).blockhash;

        doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos);
        
    }
    

    export async function getGarageAccount(blockchaininfos: BlockchainInfos): Promise<web3.AccountInfo<Buffer> | null>{

        if(!solanaConnection)
            return null; 

        if(!blockchaininfos.myAccount)
            return null; 

        const walletKey = new web3.PublicKey(blockchaininfos.myAccount);
        const programId = await new web3.PublicKey(blockchaininfos.mainContract);
        const seed = blockchaininfos.garage_seed;
        const garageKey = await web3.PublicKey.createWithSeed(walletKey, seed , programId);
        const garageAccount = await solanaConnection.getAccountInfo(garageKey);
        
        return garageAccount;
    }

    export function initPhantomMob(PhantomSession:string | null, PhantomPk:string,  SharedPk:  string){
     
        sharedPk = base58_to_binary(SharedPk);
        if(PhantomSession){
            phantomPk = base58_to_binary(PhantomPk);
            phantomSession = JSON.parse(PhantomSession);
        }
    }



    export function getAttribute(attrs: Array<attribute>, key : string){

        for(let a of attrs){
            if(a.trait_type === key)
                return a.value;
        }

        return '';
    }

    function getStrFromSer(buf: Array<number>){

        let str = '';

        for(let n=0;n<buf.length;n++){

            if(buf[n]==0)
                break;

            str += String.fromCharCode(buf[n]);
        }

        return str;
    }

    export function doDesera(schema : any, data: Uint8Array<ArrayBufferLike> | null | undefined): any{

        if(!data)
            return null;
        return deserialize(schema, data);
    }

    export async function getMetaData(id:string, TK:ToKenDef, MX:Contract, connection: web3.Connection | null = null):Promise<any>{

        if(connection!=null)
            solanaConnection = connection;
               
        const m = id.substr(0, 44);
        const k = new web3.PublicKey(m);
        const ma = await getSolanaMetadataAddress(k, TK);
        let infos = null;
        try{
            infos = await solanaConnection?.getAccountInfo(ma);
        }catch(e: any){
           console.log('getMetaData : error get account infos '+id+' '+ma.toString()+' '+e.message);
           return null;
        }

        if(infos == null){
            console.log('getMetaData : no account infos '+id+' '+ma.toString()+' ');
            return null;
        }
       
        const meta = doDesera(METADATA_MAIN_SCHEMA, infos.data);
        //console.log(meta);

        const colKey = new web3.PublicKey(meta.collection.key);
        const colAddr= colKey.toString();

        if(!meta.collection.verified){
            console.log('getMetaData : unverfied collection ');
            return null;
        }
            
        if(MX.collectionName !== colAddr ){
            console.log('getMetaData : wrong collection '+MX.collectionName+' '+colAddr);
            return null;
        }
         
        let metaJSON;

        try{
            const resp = await fetch(meta.uri);
            metaJSON = await resp.json();
            return metaJSON;
        }catch(e: any){
            console.log('getMetaData :cannot fetch asset metadata '+e.message);
            return null;
        }
    }

    export async function getTireMX(mintAddr:string, TK:ToKenDef, MX:Contract, connection : web3.Connection | null= null): Promise<TireAsset | null> {
        
        if(connection !== null)
            solanaConnection=connection;

        if(!solanaConnection)
            return null;

        let meta = null;
        let mintKey= null;
    
      try {
        mintKey = new web3.PublicKey(mintAddr);
        const mintMeta = await getSolanaMetadataAddress(mintKey, TK);
        const infos = await solanaConnection.getAccountInfo(mintMeta);
        if (!infos) {
          return null;
        }
        meta = doDesera(METADATA_MAIN_SCHEMA, infos.data);
      } catch (e) {
        return null;
      }

      if(!meta)
        return null;
    
      const colKey = new web3.PublicKey(meta.collection.key);
      const colAddr = colKey.toString();
    
      if (!meta.collection.verified)
        return null;
    
      if (MX.collectionName !== colAddr)
        return null;
    
      let metaJSON;
      try {
        const resp = await fetch(meta.uri);
        metaJSON = await resp.json();
      } catch (e) {
        return null;
      }
    
      const type = metaJSON.properties.category;
      if (!type.startsWith('tire'))
        return null;
    
      const assetClass = getAttribute(metaJSON.attributes, 'class');
    
      const asset = {
        id: mintAddr,
        template_mint:meta.editionNonce.toString(), 
        class: assetClass ? assetClass : 'C',
        claim:false,
        type: 3,
        name: getAttribute(metaJSON.attributes, 'name'),
        tire: getAttribute(metaJSON.attributes, 'tire'),
        force: parseFloat(getAttribute(metaJSON.attributes, 'force')),
        compression: parseFloat(getAttribute(metaJSON.attributes, 'compression')),
        stiffness: parseFloat(getAttribute(metaJSON.attributes, 'stiffness')),
        damping: parseFloat(getAttribute(metaJSON.attributes, 'relaxation')),
        friction: parseFloat(getAttribute(metaJSON.attributes, 'friction')),
        width: parseFloat(getAttribute(metaJSON.attributes, 'width')),
        radius: parseFloat(getAttribute(metaJSON.attributes, 'radius'))
      };
    
      return asset;
    }
    
    
    export async function getMotorMX(mintAddr:string, TK:ToKenDef, MX:Contract, connection : web3.Connection | null= null): Promise<MotorAsset | null> {
    
      let meta = null;

        if(connection !== null)
        solanaConnection=connection;

      if(!solanaConnection)
        return null;
    
      try {
        const mintKey = new web3.PublicKey(mintAddr);
        const mintMeta = await getSolanaMetadataAddress(mintKey, TK);
        const infos = await solanaConnection.getAccountInfo(mintMeta);
        if (!infos) {
          return null;
        }
        meta = doDesera(METADATA_MAIN_SCHEMA, infos.data);
      }
      catch (e) {
        return null;
      }

      if(!meta)
        return null;
        
      const colKey = new web3.PublicKey(meta.collection.key);
      const colAddr = colKey.toString();
    
      if (!meta.collection.verified)
        return null;
    
      if (MX.collectionName !== colAddr)
        return null;
    
      let metaJSON = null;
      try {
        const resp = await fetch(meta.uri);
        metaJSON = await resp.json();
      }
      catch (e) {
        return null;
      }
    
      const type = metaJSON.properties.category;
      if (!type.startsWith('motor'))
        return null;
    
      const assetClass = getAttribute(metaJSON.attributes, 'class');
    
      const asset = {
        id: mintAddr,
        type: 3,
        template_mint: meta.editionNonce.toString(),  
        claim:false,
        class: assetClass ? assetClass : 'C',
        name: getAttribute(metaJSON.attributes, 'name'),
        motor: getAttribute(metaJSON.attributes, 'motor'),
        maxEngineForce: parseFloat(getAttribute(metaJSON.attributes, 'power')),
        maxBreakingForce: parseFloat(getAttribute(metaJSON.attributes, 'braking')),
        nitro: parseFloat(getAttribute(metaJSON.attributes, 'nitro')),
        a: parseFloat(getAttribute(metaJSON.attributes, 'a')),
        b: parseFloat(getAttribute(metaJSON.attributes, 'b')),
        c: parseFloat(getAttribute(metaJSON.attributes, 'c')),
    
      };
    
      return asset;
    }
    
    export async function getBatteryMX(mintAddr:string, TK:ToKenDef, MX:Contract, connection : web3.Connection | null= null): Promise<BatteryAsset | null> {
    
      let meta = null;
    
      if(connection !== null)
        solanaConnection=connection;

      if(!solanaConnection)
        return null;
    
      try {
        const mintKey = new web3.PublicKey(mintAddr);
        const mintMeta = await getSolanaMetadataAddress(mintKey, TK);
        const infos = await solanaConnection.getAccountInfo(mintMeta);
        if (!infos) {
          return null;
        }
        meta = doDesera(METADATA_MAIN_SCHEMA, infos.data);
      }
      catch (e) {
        return null;
      }

      if(!meta)
        return null;
        
      const colKey = new web3.PublicKey(meta.collection.key);
      const colAddr = colKey.toString();
    
      if (!meta.collection.verified)
        return null;
    
      if (MX.collectionName !== colAddr)
        return null;
    
      let metaJSON = null;
      try {
        const resp = await fetch(meta.uri);
        metaJSON = await resp.json();
      }
      catch (e) {
        return null;
      }
    
      const type = metaJSON.properties.category;
      if (!type.startsWith('battery'))
        return null;
    
      const assetClass = getAttribute(metaJSON.attributes, 'class');
    
      const asset = {
        id: mintAddr,
        type: 3,
        template_mint: meta.editionNonce.toString(),  
        claim:false,
        class: assetClass ? assetClass : 'C',
        name: getAttribute(metaJSON.attributes, 'name'),
        model: getAttribute(metaJSON.attributes, 'model'),
        power: parseFloat(getAttribute(metaJSON.attributes, 'power')),
        charge: parseFloat(getAttribute(metaJSON.attributes, 'charge'))    
      };
    
      return asset;
    }

    export async function getRadarMX(mintAddr:string, TK:ToKenDef, MX:Contract, connection : web3.Connection | null= null): Promise<RadarAsset | null> {
    
      let meta = null;

      if(connection !== null)
        solanaConnection=connection;

      if(!solanaConnection){
        console.log('getRadarMX no connection ');
        return null;
      }
        
    
      try {
        const mintKey = new web3.PublicKey(mintAddr);
        const mintMeta = await getSolanaMetadataAddress(mintKey, TK);
        const infos = await solanaConnection.getAccountInfo(mintMeta);
        if (!infos) {

            console.log('getRadarMX no account info '+mintAddr+' '+mintMeta.toString());
          return null;
        }
        meta = doDesera(METADATA_MAIN_SCHEMA, infos.data);
      }
      catch (e:any) {
        console.log('getRadarMX error :'+e.message);
        return null;
      }

      if(!meta){
        console.log('getRadarMX unable to deserialize asset meta');
        return null;
      }
        
        
      const colKey = new web3.PublicKey(meta.collection.key);
      const colAddr = colKey.toString();
    
      if (!meta.collection.verified){
        console.log('getRadarMX unverfied collection');
        return null;
      }
        
    
      if (MX.collectionName !== colAddr){
        console.log('getRadarMX wrong collection');
        return null;
      }
        
    
      let metaJSON = null;
      try {
        const resp = await fetch(meta.uri);
        metaJSON = await resp.json();
      }
      catch (e) {
        console.log('getRadarMX unable to fetch meta');
        return null;
      }
    
      const type = metaJSON.properties.category;
      if (!type.startsWith('radar')){
        console.log('getRadarMX wrong asset type');
        return null;
      }
    
      const assetClass = getAttribute(metaJSON.attributes, 'class');
    
      const asset = {
        id: mintAddr,
        type: 3,
        template_mint: meta.editionNonce.toString(),  
        claim:false,
        class: assetClass ? assetClass : 'C',
        name: getAttribute(metaJSON.attributes, 'name'),
        model: getAttribute(metaJSON.attributes, 'model'),
        power: parseFloat(getAttribute(metaJSON.attributes, 'power')),
        range: parseFloat(getAttribute(metaJSON.attributes, 'range')),
        angle: parseFloat(getAttribute(metaJSON.attributes, 'angle'))
      };
    
      return asset;
    }

    export async function getWeaponMX(mintAddr:string, TK:ToKenDef, MX:Contract, connection : web3.Connection | null= null): Promise<WeaponAsset | null> {
    
      let meta = null;

      
      if(connection !== null)
        solanaConnection=connection;

      if(!solanaConnection)
        return null;
    
      try {
        const mintKey = new web3.PublicKey(mintAddr);
        const mintMeta = await getSolanaMetadataAddress(mintKey, TK);
        const infos = await solanaConnection.getAccountInfo(mintMeta);
        if (!infos) {
          return null;
        }
        meta = doDesera(METADATA_MAIN_SCHEMA, infos.data);
      }
      catch (e) {
        return null;
      }

      if(!meta)
        return null;
        
      const colKey = new web3.PublicKey(meta.collection.key);
      const colAddr = colKey.toString();
    
      if (!meta.collection.verified)
        return null;
    
      if (MX.collectionName !== colAddr)
        return null;
    
      let metaJSON = null;
      try {
        const resp = await fetch(meta.uri);
        metaJSON = await resp.json();
      }
      catch (e) {
        return null;
      }

      if(!metaJSON)
        return null;
    
      const type = metaJSON.properties.category;
      if (!type.startsWith('weapon'))
        return null;
    
      const assetClass = getAttribute(metaJSON.attributes, 'class');
    
      const asset = {
        id: mintAddr,
        type: 3,
        template_mint: meta.editionNonce.toString(),  
        claim:false,
        class: assetClass ? assetClass : 'C',
        name: getAttribute(metaJSON.attributes, 'name'),
        model: getAttribute(metaJSON.attributes, 'model'),
        projSpeed: parseFloat(getAttribute(metaJSON.attributes, 'speed')), 
        projMass: parseFloat(getAttribute(metaJSON.attributes, 'mass')) , 
        projDelay : parseFloat(getAttribute(metaJSON.attributes, 'rate')) , 
        projSize : parseFloat(getAttribute(metaJSON.attributes, 'size')), 
        power : parseFloat(getAttribute(metaJSON.attributes, 'power')),
        durability : parseFloat(getAttribute(metaJSON.attributes, 'durability')), 
        dmg :  parseFloat(getAttribute(metaJSON.attributes, 'dmg')), 
        blastForce : parseFloat(getAttribute(metaJSON.attributes, 'blastForce')), 
        blastRadius : parseFloat(getAttribute(metaJSON.attributes, 'blastRadius'))
      };

      
    
      return asset;
    }

    export  async function getCarMX(id : string, account: string | null  = null, TK:ToKenDef, MX : Contract, connection :web3.Connection|null = null){

        if(!solanaConnection){
            if(connection !== null)
                solanaConnection=connection
            else{
                console.log('getCarMX: no solanna connection ');
                return null;
            }
        }
            
        if(id.length<43){
            console.log('getCarMX: wrong id '+id);
            return null;
        }
            
        const m = id.substr(0, 44);
        const k = new web3.PublicKey(m);
        const ma = await getSolanaMetadataAddress(k, TK);
        let infos = null;
        try{
            infos = await solanaConnection?.getAccountInfo(ma);
        }catch(e: any){
           console.log('getCarMX : error get account '+e.message+' '+m);
            return null;
        }

        if(infos == null){
            console.log('getCarMX : error get account '+id);
            return null;
        }
       
        
        const meta = doDesera(METADATA_MAIN_SCHEMA, infos.data);
        //console.log(meta);

        const colKey = new web3.PublicKey(meta.collection.key);
        const colAddr= colKey.toString();

        if(!meta.collection.verified){
            console.log('getCarMX : unverfied collection ');
            return null;
        }
            
        if(MX.collectionName !== colAddr ){
            console.log('getCarMX : wrong collection '+MX.collectionName+' '+colAddr);
            return null;
        }
         
        let metaJSON;

        try{
            const resp = await fetch(meta.uri);
            metaJSON = await resp.json();
        }catch(e: any){
            console.log('getCarMX :cannot fetch asset metadata '+e.message);
            return null;
        }

        const type = getAttribute(metaJSON.attributes,'type');

        if(type !== 'car'){
            console.log('wrong asset type')
            return null;
        }
            

        const sustxt = getAttribute(metaJSON.attributes,'suspension');
        const mottxt = getAttribute(metaJSON.attributes,'motor');
        const battxt = getAttribute(metaJSON.attributes,'battery');
        const radtxt = getAttribute(metaJSON.attributes,'radar');
        const weaptxt = getAttribute(metaJSON.attributes,'weapon');

        const isuspension = sustxt.length > 0 ? JSON.parse(sustxt) : null;
        const imotor = mottxt.length > 0 ? JSON.parse(mottxt) : null;
        const ibattery = battxt.length > 0 ? JSON.parse(battxt) : null;
        const iradar = radtxt.length > 0 ? JSON.parse(radtxt) : null;
        const iweapon = weaptxt.length > 0 ? JSON.parse(weaptxt) : null;
        
        const suspension = isuspension ?    {   id:isuspension.mint.toString(), 
                                                type: 2, 
                                                template_mint : '0', 
                                                claim:false,
                                                name: isuspension.name, 
                                                class: isuspension.class, 
                                                tire: isuspension.tire, 
                                                force: parseFloat(isuspension.force), 
                                                compression: parseFloat(isuspension.compression), 
                                                stiffness: parseFloat(isuspension.stiffness), 
                                                damping: parseFloat(isuspension.relaxation), 
                                                friction: parseFloat(isuspension.friction),
                                                width: isuspension.width ? parseFloat(isuspension.width) : 0.2,
                                                radius: isuspension.radius ? parseFloat(isuspension.radius) : 0.3,
                                            }: null;

        const motor = imotor ? 
        {
            id:imotor.mint.toString(), 
            type: 2, 
            template_mint : '0', 
            claim:false,            
            name: imotor.name, 
            class: imotor.class, 
            motor: imotor.motor, 
            maxEngineForce: parseFloat(imotor.power), 
            maxBreakingForce: parseFloat(imotor.braking),
            nitro: imotor.nitro ? parseFloat(imotor.nitro) : 1.0,
            a : parseFloat(imotor.a),
            b : parseFloat(imotor.b),
            c : parseFloat(imotor.c),
        }: null;


        const battery = ibattery ? 
        {
            id:ibattery.mint.toString(), 
            type: 2, 
            template_mint : '0', 
            claim:false,            
            name: ibattery.name, 
            class: ibattery.class, 
            model: ibattery.model,
            charge: parseFloat(ibattery.charge), 
            power : parseFloat(ibattery.power) 
        }: null;

        
        const radar = iradar ? 
        {
            id:iradar.mint.toString(), 
            type: 2, 
            template_mint : '0', 
            claim:false,            
            name: iradar.name, 
            class: iradar.class, 
            model: iradar.model,
            angle: parseFloat(iradar.angle), 
            range: parseFloat(iradar.range) , 
            power : parseFloat(iradar.power)
        }: null;

        const weapon = iweapon ? 
        {
            id:iweapon.mint.toString(), 
            type: 2, 
            template_mint : '0', 
            claim:false,            
            name: iweapon.name, 
            class: iweapon.class, 
            model: iweapon.model,

            projSpeed: parseFloat(iweapon.speed), 
            projMass: parseFloat(iweapon.mass) , 
            projDelay : parseFloat(iweapon.rate) , 
            projSize : parseFloat(iweapon.size) * 10, 
            power : parseFloat(iweapon.power),
            durability : parseFloat(iweapon.durability), 
            dmg :  parseFloat(iweapon.dmg), 
            blastForce : parseFloat(iweapon.blastForce), 
            blastRadius : parseFloat(iweapon.blastRadius)
        }: null;

        const asset = { id: id, 
            template_mint: meta.editionNonce.toString(), 
            class: getAttribute(metaJSON.attributes , 'class'), 
            type: 3, 
            isfree:false,
            claim:false,
            isDemo : false,
            name: getAttribute(metaJSON.attributes , 'name'), 
            chassis: getAttribute(metaJSON.attributes, 'chassis'), 
            massVehicle: parseFloat(getAttribute(metaJSON.attributes, 'massvehicle')), 
            steeringClamp: parseFloat(getAttribute(metaJSON.attributes , 'steeringclamp')), 
            steeringIncrement: parseFloat(getAttribute(metaJSON.attributes , 'steeringincrement')), 
            suspensionRestLength: parseFloat(getAttribute(metaJSON.attributes , 'suspensionLength')), 
            maxdmg: parseFloat(getAttribute(metaJSON.attributes ,'maxdmg')), 
            suspension: suspension, 
            motor: motor, 
            weapon: weapon, 
            radar : radar, 
            battery : battery, 
            mdata : null,
            DMG: null  
        };
        return asset;
    }


    export async function getGarageCar(account: string | null, mainContract: string, garage_seed: string,  n : number, TK:ToKenDef, MX:Contract ): Promise<carAsset | null>{

        if(account === null)
            return null;
        const programId = await new web3.PublicKey(mainContract);
        const seed = garage_seed;
        const userKey = await new web3.PublicKey(account);
        const garageKey = await web3.PublicKey.createWithSeed(userKey, seed , programId);
        let garageData = null;

        try{
            const garageAccount = await solanaConnection?.getAccountInfo(garageKey);
            if(!garageAccount){
                console.log('getGarageCar :: no garageAccount')
                return null;
            }
            garageData = doDesera(METADATA_GARAGE_SCHEMA, garageAccount.data);
        }
        catch(e){
            return null;
        }
        if(!garageData){
                console.log('getGarageCar :: no garageData')
                return null;
            }
        if(n>=garageData.cars.length){
            console.log('getGarageCar :: invalid car slot')
            return null;
        }

        const car = garageData.cars[n];
        console.log(car);

        if(car.name[0]===0)
            return null;

        const tiremint = binary_to_base58(car.suspension.mint);

        const suspension = car.suspension.name[0] !== 0 ?{  id : tiremint,
                                                            template_mint : '?',
                                                            type : 2,
                                                            claim:false,
                                                            name: getStrFromSer(car.suspension.name), 
                                                            tire: getStrFromSer(car.suspension.tire), 
                                                            class: classes[car.suspension.class], 
                                                            force: car.suspension.force, 
                                                            compression: car.suspension.compression, 
                                                            stiffness: car.suspension.stiffness, 
                                                            damping: car.suspension.damping, 
                                                            friction: car.suspension.friction,
                                                            width: car.suspension.width,
                                                            radius: car.suspension.radius
                                                    }: null;


        let motor = null;
                                                    
        if(car.motor.name[0] !== 0){

            const motormint = binary_to_base58(car.motor.mint);
            const json = await getMetaData(motormint, TK, MX);

            motor = {
                id : motormint,
                template_mint : '?',
                type : 2,
                claim:false,
                name: getAttribute(json.attributes, 'name'),
                class: classes[parseInt(getAttribute(json.attributes, 'class'))], 
                motor: getAttribute(json.attributes, 'motor'),
                maxEngineForce: parseFloat(getAttribute(json.attributes, 'power')),
                maxBreakingForce: parseFloat(getAttribute(json.attributes, 'braking')),
                nitro: parseFloat(getAttribute(json.attributes, 'nitro')),
                a: parseFloat(getAttribute(json.attributes, 'a')),
                b: parseFloat(getAttribute(json.attributes, 'b')),
                c: parseFloat(getAttribute(json.attributes, 'c')),
            };
        }

        let battery = null;
                                                    
        if(car.battery.name[0] !== 0){

            const batterymint = binary_to_base58(car.battery.mint);
            const json = await getMetaData(batterymint, TK, MX);

            battery = {
                id : batterymint,
                template_mint : '?',
                type : 2,
                claim:false,
                name: getAttribute(json.attributes, 'name'),
                class: classes[parseInt(getAttribute(json.attributes, 'class'))], 
                model: getAttribute(json.attributes, 'model'),
                power: parseFloat(getAttribute(json.attributes, 'power')),
                charge: parseFloat(getAttribute(json.attributes, 'charge'))
            };
        }
        
        
        let radar = null;
                                                    
        if(car.radar.name[0] !== 0){

            const radarmint = binary_to_base58(car.radar.mint);
            const json = await getMetaData(radarmint, TK, MX);

            console.log(json.attributes);
            radar = {
                id : radarmint,
                template_mint : '?',
                type : 2,
                claim:false,
                name: getAttribute(json.attributes, 'name'),
                class: classes[parseInt(getAttribute(json.attributes, 'class'))], 
                model: getAttribute(json.attributes, 'model'),
                power: parseFloat(getAttribute(json.attributes, 'power')),
                range: parseFloat(getAttribute(json.attributes, 'range')),
                angle: parseFloat(getAttribute(json.attributes, 'angle'))
            };
        }

        let weapon = null;
                                                    
        if(car.weapon.name[0] !== 0){

            const weaponint = binary_to_base58(car.weapon.mint);
            const json = await getMetaData(weaponint, TK, MX);

            //console.log(json.attributes);
            weapon = {
                id : weaponint,
                template_mint : '?',
                type : 2,
                claim:false,
                name: getAttribute(json.attributes, 'name'),
                class: classes[parseInt(getAttribute(json.attributes, 'class'))], 
                model: getAttribute(json.attributes, 'model'),

                
                projSpeed: parseFloat(getAttribute(json.attributes, 'speed')),
                projMass: parseFloat(getAttribute(json.attributes, 'mass')),
                projDelay: parseFloat(getAttribute(json.attributes, 'rate')),
                projSize: parseFloat(getAttribute(json.attributes, 'size')),
                power: parseFloat(getAttribute(json.attributes, 'power')),
                durability: parseFloat(getAttribute(json.attributes, 'durability')),
                dmg: parseFloat(getAttribute(json.attributes, 'dmg')),
                blastForce: parseFloat(getAttribute(json.attributes, 'blastForce')),
                blastRadius: parseFloat(getAttribute(json.attributes, 'blastRadius'))
            };
        }

        const asset = { id: n.toString(), 
                        template_mint: '?', 
                        //mint : mintkey,
                        class: classes[car.class], 
                        claim:false,
                        isfree:false,
                        isDemo : false,
                        weapon: weapon,
                        radar: radar,
                        battery: battery,
                        type: 2, 
                        name: getStrFromSer(car.name), 
                        chassis: getStrFromSer(car.chassis), 
                        massVehicle: car.massvehicle, 
                        steeringClamp: car.steeringclamp, 
                        steeringIncrement: car.steeringincrement, 
                        maxdmg: car.maxdmg, 
                        suspensionRestLength: car.suspensionLength, 
                        suspension: suspension, 
                        motor: motor, 
                        mdata:null,
                        DMG: null
                       
        };

        console.log(asset);

        return asset;
    }

    async function getGarageTire(myAccount :string,mainContract:string, garage_seed:string, n : number, TK: ToKenDef, MX:Contract){
        const pk = new web3.PublicKey(myAccount);
        const programId = await new web3.PublicKey(mainContract);
        const seed = garage_seed;
        const garageKey = await web3.PublicKey.createWithSeed(pk, seed , programId);
        const garageAccount = await solanaConnection?.getAccountInfo(garageKey);
        if(!garageAccount)
            return null;

        const garageData = doDesera(METADATA_GARAGE_SCHEMA, garageAccount.data);

        if(n>=garageData.tires.length)
            return null;

        const tire = garageData.tires[n];

        if(tire.name[0]===0)
            return null;



        const asset = {   
                        id: n.toString(), 
                        template_mint: "-1", 
                        type: 2, 
                        claim:false,
                        class:tire.class,
                        name: getStrFromSer(tire.name), 
                        tire: getStrFromSer(tire.tire), 
                        force: tire.force, 
                        compression: tire.compression, 
                        stiffness: tire.stiffness, 
                        damping: tire.damping, 
                        friction: tire.friction,
                        radius:tire.radius,
                        width: tire.width
                      };


        return asset;

    }

    async function getGarageMotor(myAccount : string,mainContract: string, garage_seed: string, n : number, TK: ToKenDef, MX:Contract){
        const pk = new web3.PublicKey(myAccount);
        const programId = await new web3.PublicKey(mainContract);
        const seed = garage_seed;
        const garageKey = await web3.PublicKey.createWithSeed(pk, seed , programId);
        const garageAccount = await solanaConnection?.getAccountInfo(garageKey);
        if(!garageAccount)
            return null;

        const garageData = doDesera(METADATA_GARAGE_SCHEMA, garageAccount.data);

        if(n>=garageData.motors.length)
            return null;

        const motor = garageData.motors[n];

        if(motor.name[0]===0)
            return null;

        const motormint = binary_to_base58(motor.mint);
        const json = await getMetaData(motormint, TK, MX);

        const asset = {   
                        id: n.toString(), 
                        template_mint: '-1', 
                        type: 2, 
                        claim:false,
                        name: getStrFromSer(motor.name), 
                        motor: getAttribute(json.attributes,'motor'), 
                        maxEngineForce: parseFloat(getAttribute(json.attributes,'power')), 
                        maxBreakingForce: parseFloat(getAttribute(json.attributes,'braking')), 

                        class: classes[parseInt(getAttribute(json.attributes,'class'))], 
                        nitro: parseFloat(getAttribute(json.attributes,'nitro')),
                        a: parseFloat(getAttribute(json.attributes,'a')),
                        b: parseFloat(getAttribute(json.attributes,'b')),
                        c: parseFloat(getAttribute(json.attributes,'c'))
                      };
                     

        return asset;

    }

    async function getGarageBattery(myAccount : string,mainContract: string, garage_seed: string, n : number, TK: ToKenDef, MX:Contract){
        const pk = new web3.PublicKey(myAccount);
        const programId = await new web3.PublicKey(mainContract);
        const seed = garage_seed;
        const garageKey = await web3.PublicKey.createWithSeed(pk, seed , programId);
        const garageAccount = await solanaConnection?.getAccountInfo(garageKey);
        if(!garageAccount)
            return null;

        const garageData = doDesera(METADATA_GARAGE_SCHEMA, garageAccount.data);

        if(n>=garageData.batteries.length)
            return null;

        const battery = garageData.batteries[n];

        if(battery.name[0]===0)
            return null;
        

        const batterymint = binary_to_base58(battery.mint);
        const json = await getMetaData(batterymint, TK, MX);

        const asset = {   
                        id: n.toString(), 
                        template_mint: '-1', 
                        name: getStrFromSer(battery.name), 
                        type: 2, 
                        claim:false,
                        class:  classes[parseInt(getAttribute(json.attributes,'class'))], 
                        model: getAttribute(json.attributes,'model'), 
                        power: parseFloat(getAttribute(json.attributes,'power')),
                        charge: parseFloat(getAttribute(json.attributes,'charge'))
                      };
                     

        return asset;
    }

    async function getGarageRadar(myAccount : string,mainContract: string, garage_seed: string, n : number, TK: ToKenDef, MX:Contract){
        
        const pk = new web3.PublicKey(myAccount);
        const programId = await new web3.PublicKey(mainContract);
        const seed = garage_seed;
        const garageKey = await web3.PublicKey.createWithSeed(pk, seed , programId);
        const garageAccount = await solanaConnection?.getAccountInfo(garageKey);
        if(!garageAccount)
            return null;

        const garageData = doDesera(METADATA_GARAGE_SCHEMA, garageAccount.data);

        if(n>=garageData.radars.length)
            return null;

        const radar = garageData.radars[n];

        if(radar.name[0]===0)
            return null;

        const radarmint = binary_to_base58(radar.mint);
        const json = await getMetaData(radarmint, TK, MX);

        const asset = {   
                        id: n.toString(), 
                        template_mint: '-1', 
                        type: 2, 
                        claim:false,
                        name: getStrFromSer(radar.name), 
                        class: classes[parseInt(getAttribute(json.attributes,'class'))], 
                        model: getAttribute(json.attributes,'model'), 
                        power: parseFloat(getAttribute(json.attributes,'power')),
                        range: parseFloat(getAttribute(json.attributes,'range')),
                        angle: parseFloat(getAttribute(json.attributes,'angle'))
                      };
                     

        return asset;
    }

    
    async function getGarageWeapon(myAccount : string,mainContract: string, garage_seed: string, n : number, TK: ToKenDef, MX:Contract){
        const pk = new web3.PublicKey(myAccount);
        const programId = await new web3.PublicKey(mainContract);
        const seed = garage_seed;
        const garageKey = await web3.PublicKey.createWithSeed(pk, seed , programId);
        const garageAccount = await solanaConnection?.getAccountInfo(garageKey);
        if(!garageAccount)
            return null;

        const garageData = doDesera(METADATA_GARAGE_SCHEMA, garageAccount.data);

        if(n>=garageData.weapons.length)
            return null;

        const weapon = garageData.weapons[n];

        if(weapon.name[0]===0)
            return null;

        const weaponmint = binary_to_base58(weapon.mint);
        if(weaponmint == "11111111111111111111111111111111")
            return null;

        const json = await getMetaData(weaponmint, TK, MX);

        const asset = {   
                        id: n.toString(), 
                        template_mint: '-1', 
                        type: 2, 
                        claim:false,
                        name: getStrFromSer(weapon.name), 
                        class: classes[parseInt(getAttribute(json.attributes,'class'))], 
                        model: getAttribute(json.attributes,'model'), 
                        projSpeed:parseFloat(getAttribute(json.attributes,'speed')),
                        projMass:parseFloat(getAttribute(json.attributes,'mass')),
                        projDelay:parseFloat(getAttribute(json.attributes,'rate')),
                        projSize:parseFloat(getAttribute(json.attributes,'size')),
                        power:parseFloat(getAttribute(json.attributes,'power')),
                        durability:parseFloat(getAttribute(json.attributes,'durability')),
                        dmg:parseFloat(getAttribute(json.attributes,'dmg')),
                        blastForce:parseFloat(getAttribute(json.attributes,'blastForce')),
                        blastRadius:parseFloat(getAttribute(json.attributes,'blastRadius')),
                      };
                     

        return asset;
    }


    export async function getSolanaMetadataAddress(tokenMint:web3.PublicKey, TK: ToKenDef) {


        const METADATA_PREFIX = "metadata";

        const metaProgamPublicKey = new web3.PublicKey(TK.metadata);
        const metaProgamPublicKeyBuffer = metaProgamPublicKey.toBuffer();
        const metaProgamPrefixBuffer = new TextEncoder().encode(METADATA_PREFIX);

        return ( await web3.PublicKey.findProgramAddress([metaProgamPrefixBuffer, metaProgamPublicKeyBuffer, tokenMint.toBuffer()], metaProgamPublicKey ) )[0];
    }

    export async function getSolanaEditionAddress(tokenMint:web3.PublicKey, TK: ToKenDef) {

        
        const METADATA_PREFIX = "metadata";
        const METADATA_SUFFIX = "edition";
      
        const metaProgamPublicKey = new web3.PublicKey(TK.metadata);
        const metaProgamPublicKeyBuffer = metaProgamPublicKey.toBuffer();
        const metaProgamPrefixBuffer = new TextEncoder().encode(METADATA_PREFIX);
        const metaProgamSuffixBuffer = new TextEncoder().encode(METADATA_SUFFIX);
      
        return ( await web3.PublicKey.findProgramAddress([metaProgamPrefixBuffer, metaProgamPublicKeyBuffer, tokenMint.toBuffer(), metaProgamSuffixBuffer], metaProgamPublicKey ) )[0];
    }



export async function getAssetsMX (assetLists: assetList, myAccount : string, categories : Array<string>, garage_seed : string, mainContract:string, MX:Contract, TK : ToKenDef) {

        if(!solanaConnection){
            console.log('getAssetsMX: no connection')
            return;
        }

        if(!TK.contract){
            console.log('getAssetsMX: no TK contract')
            return;
        }

        for(let cat of categories){
            switch(cat){
                case 'tires':assetLists.tires = [];break;
                case 'motors':assetLists.motors = [];break;
                case 'batteries':assetLists.batteries = [];break;
                case 'radars':assetLists.radars = [];break;
                case 'weapons':assetLists.weapons = [];break;
            }
        }
        

        const TOKEN_PROGRAM_ID = new web3.PublicKey(TK.contract);
        //const TOKEN_2022_PROGRAM_ID = new this.web3.PublicKey('TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb');

        const programId = await new web3.PublicKey(mainContract);

        if(categories.indexOf('cars')>=0){
            const gcar = await getGarageCar(myAccount, mainContract, garage_seed, 0, TK, MX);
            if(gcar)
                assetLists['cars'].push(gcar);
            
        }

        if(categories.indexOf('tires')>=0){
            for(let n=0;n<1;n++){
                const gtire = await getGarageTire(myAccount, mainContract, garage_seed,n, TK, MX);
                if(gtire !== null){
                    assetLists['tires'].push(gtire);
                }
                    
            }
        }
        
        if(categories.indexOf('motors')>=0){
            for(let n=0;n<1;n++){
                const gmotor = await getGarageMotor(myAccount,mainContract, garage_seed,n, TK, MX);
                if(gmotor !== null)
                    assetLists['motors'].push(gmotor);
            }
        }
        
        if(categories.indexOf('batteries')>=0){
            for(let n=0;n<1;n++){
                const gbattery = await getGarageBattery(myAccount,mainContract, garage_seed,n, TK, MX);
                if(gbattery !== null)
                    assetLists['batteries'].push(gbattery);
            }
        }

        if(categories.indexOf('weapons')>=0){
            for(let n=0;n<1;n++){
                const gweapons = await getGarageWeapon(myAccount,mainContract, garage_seed,n, TK, MX);
                if(gweapons !== null)
                    assetLists['weapons'].push(gweapons);
            }
        }

        if(categories.indexOf('radars')>=0){
            for(let n=0;n<1;n++){
                const gradars = await getGarageRadar(myAccount,mainContract, garage_seed,n, TK, MX);
                if(gradars !== null)
                    assetLists['radars'].push(gradars);
            }
        }
                
        const maa = [];
        const edas = [];
        const upk = new web3.PublicKey(myAccount);
        let nfts = null;

        try{
            const result = await solanaConnection?.getParsedTokenAccountsByOwner(upk, {programId : TOKEN_PROGRAM_ID},);
            console.log('result : ', result);
            nfts = result?.value;
        }
        catch(e){
            return;
        }

        if(!nfts)
            return;

        for(let n=0;n<nfts.length;n++){
            const nft = nfts[n];

            const a = nft.account.data.parsed.info.tokenAmount.uiAmount;
            const d = nft.account.data.parsed.info.tokenAmount.decimals;

            if(d != 0)
                continue;

            if(a < 1)
                continue;            

            const m = new web3.PublicKey(nft.account.data.parsed.info.mint);
            const ma = await getSolanaMetadataAddress(m, TK);
            const ed = await getSolanaEditionAddress(m, TK);
            maa.push(ma);
            edas.push(ed);
        }

        const infos = await solanaConnection.getMultipleAccountsInfo(maa);
        const eds = await solanaConnection.getMultipleAccountsInfo(edas);

        for(let n=0;n<infos.length;n++){

            if(!infos[n])
                continue;
            
            if(!eds[n])
                continue;

            const meta = doDesera(METADATA_MAIN_SCHEMA, infos[n]?.data);
            const colKey = new web3.PublicKey(meta.collection.key);
            const colAddr= colKey.toString();

            let edition;

            
            switch(eds[n]?.data[0]){
                //master edition
                case 6: edition = 0; break;
                //editionV1
                case 1: 
                    const edi = doDesera({struct : {'key' : 'u8', 'parent' : 'pubkey' , 'edition' : 'u64'}}, eds[n]?.data);
                    edition = edi.edition;
                break;
                default:
                    console.warn('unknown edition account '+eds[n]?.data[0]);
                break;
            }

            if(!meta.collection.verified)
                continue;

            if(MX.collectionName !== colAddr )
                continue;

            const mintKey = new web3.PublicKey(meta.mint);
            const mintAddr= mintKey.toString();

            const id = mintAddr;
            const resp = await fetch(meta.uri);
            const metaJSON = await resp.json();
            const type = getAttribute(metaJSON.attributes,'type');

            if(type === 'car'){

                if(categories.indexOf('cars')<0)
                    continue;

                const sustxt = getAttribute(metaJSON.attributes,'suspension');
                const mottxt = getAttribute(metaJSON.attributes,'motor');
                const battxt = getAttribute(metaJSON.attributes,'battery');
                const radtxt = getAttribute(metaJSON.attributes,'radar');
                const weaptxt = getAttribute(metaJSON.attributes,'weapon');



                const isuspension = sustxt.length > 0 ? JSON.parse(sustxt) : null;
                const imotor = mottxt.length > 0 ? JSON.parse(mottxt) : null;
                const ibattery = battxt.length > 0 ? JSON.parse(battxt) : null;
                const iradar = radtxt.length > 0 ? JSON.parse(radtxt) : null;
                const iweapon = weaptxt.length > 0 ? JSON.parse(weaptxt) : null;

        
                const suspension = isuspension ?    {   
                                                        id: isuspension.mint.toString(), 
                                                        template_mint: '?', 
                                                        type: 2, 
                                                        claim:false,
                                                        class:getAttribute(metaJSON.attributes , 'class'), 
                                                        name: isuspension.name, 
                                                        tire: isuspension.tire, 
                                                        force: parseFloat(isuspension.force), 
                                                        compression: parseFloat(isuspension.compression), 
                                                        stiffness: parseFloat(isuspension.stiffness), 
                                                        damping: parseFloat(isuspension.relaxation), 
                                                        friction: parseFloat(isuspension.friction),
                                                        radius: parseFloat(isuspension.radius),
                                                        width: parseFloat(isuspension.width)
                                                        
                                                    }: null;
                const motor = imotor ? 
                {
                    id: imotor.mint.toString(), 
                    template_mint: '?', 
                    type: 2, 
                    claim:false,
                    class:imotor.class?imotor.class: 0, 
                    nitro:imotor.nitro?imotor.nitro: 0, 
                    a:imotor.a?imotor.a: 0, 
                    b:imotor.b?imotor.b: 0, 
                    c:imotor.c?imotor.c: 0, 
                    name: imotor.name, 
                    motor: imotor.motor, 
                    maxEngineForce: parseFloat(imotor.power), 
                    maxBreakingForce: parseFloat(imotor.braking)
                }: null;

                const battery = ibattery ? 
                {
                    id:ibattery.mint.toString(), 
                    type: 2, 
                    template_mint : '0', 
                    claim:false,            
                    name: ibattery.name, 
                    class: ibattery.class, 
                    model: ibattery.model,
                    charge: parseFloat(ibattery.charge), 
                    power : parseFloat(ibattery.power) 
                }: null;

                
                const radar = iradar ? 
                {
                    id:iradar.mint.toString(), 
                    type: 2, 
                    template_mint : '0', 
                    claim:false,            
                    name: iradar.name, 
                    class: iradar.class, 
                    model: iradar.model,
                    angle: parseFloat(iradar.angle), 
                    range: parseFloat(iradar.range) , 
                    power : parseFloat(iradar.power)
                }: null;

                const weapon = iweapon ? 
                {
                    id:iweapon.mint.toString(), 
                    type: 2, 
                    template_mint : '0', 
                    claim:false,            
                    name: iweapon.name, 
                    class: iweapon.class, 
                    model: iweapon.model,

                    projSpeed: parseFloat(iweapon.speed), 
                    projMass: parseFloat(iweapon.mass) , 
                    projDelay : parseFloat(iweapon.rate) , 
                    projSize : parseFloat(iweapon.size) * 10, 
                    power : parseFloat(iweapon.power),
                    durability : parseFloat(iweapon.durability), 
                    dmg :  parseFloat(iweapon.dmg), 
                    blastForce : parseFloat(iweapon.blastForce), 
                    blastRadius : parseFloat(iweapon.blastRadius)
                }: null;

                const asset = { id: id, 
                                template_mint: edition.toString(), 
                                type: 3, 
                                isfree:false,
                                claim:false, 
                                class:getAttribute(metaJSON.attributes , 'class'), 
                                suspensionRestLength: parseFloat(getAttribute(metaJSON.attributes , 'suspensionRestLength')), 
                                isDemo : false,
                                name: getAttribute(metaJSON.attributes , 'name'), 
                                chassis: getAttribute(metaJSON.attributes, 'chassis'), 
                                massVehicle: parseFloat(getAttribute(metaJSON.attributes, 'massVehicle')), 
                                steeringClamp: parseFloat(getAttribute(metaJSON.attributes , 'steeringClamp')), 
                                steeringIncrement: parseFloat(getAttribute(metaJSON.attributes , 'steeringIncrement')), 
                                maxdmg: parseFloat(getAttribute(metaJSON.attributes ,'maxdmg')), 
                                suspension: suspension, 
                                motor: motor, 
                                weapon: weapon,
                                radar: radar,
                                battery: battery,
                                mdata: null,
                                DMG: null
                            };

                assetLists.cars.push(asset);

            }else if(type === 'tire'){

                if(categories.indexOf('tires')<0)
                    continue;


                const asset = { id: id, 
                                template_mint: edition.toString(), 
                                type: 3,
                                claim:false, 
                                class:getAttribute(metaJSON.attributes, 'class'), 
                                name: getAttribute(metaJSON.attributes, 'name'), 
                                tire: getAttribute(metaJSON.attributes ,'tire'), 
                                force: parseFloat(getAttribute(metaJSON.attributes , 'force')), 
                                compression: parseFloat(getAttribute(metaJSON.attributes , 'compression')), 
                                stiffness: parseFloat(getAttribute(metaJSON.attributes , 'stiffness')), 
                                damping: parseFloat(getAttribute(metaJSON.attributes, 'relaxation')), 
                                friction: parseFloat(getAttribute(metaJSON.attributes, 'friction')),
                                radius: parseFloat(getAttribute(metaJSON.attributes, 'radius')),
                                width: parseFloat(getAttribute(metaJSON.attributes, 'width'))
                            };

                assetLists.tires.push(asset);

            }else if(type === 'battery'){

                if(categories.indexOf('batteries')<0)
                    continue;

                const asset = { id: id, 
                                template_mint: edition.toString(), 
                                type: 3,
                                claim:false, 
                                class:getAttribute(metaJSON.attributes, 'class'), 
                                name: getAttribute(metaJSON.attributes, 'name'), 
                                model: getAttribute(metaJSON.attributes ,'model'), 
                                power: parseFloat(getAttribute(metaJSON.attributes , 'power')), 
                                charge: parseFloat(getAttribute(metaJSON.attributes , 'charge'))
                            };

                assetLists.batteries.push(asset);

            }else if(type === 'radar'){

                if(categories.indexOf('radars')<0)
                    continue;


                const asset = { id: id, 
                                template_mint: edition.toString(), 
                                type: 3,
                                claim:false, 
                                class:getAttribute(metaJSON.attributes, 'class'), 
                                name: getAttribute(metaJSON.attributes, 'name'), 
                                model: getAttribute(metaJSON.attributes ,'model'),  
                                power: parseFloat(getAttribute(metaJSON.attributes , 'power')), 
                                range: parseFloat(getAttribute(metaJSON.attributes , 'range')), 
                                angle: parseFloat(getAttribute(metaJSON.attributes , 'angle'))
                            };

                assetLists.radars.push(asset);

            }else if(type === 'weapon'){

                if(categories.indexOf('weapons')<0)
                    continue;


                const asset = { id: id, 
                                template_mint: edition.toString(), 
                                type: 3,
                                claim:false, 
                                class:getAttribute(metaJSON.attributes, 'class'), 
                                name: getAttribute(metaJSON.attributes, 'name'), 
                                model: getAttribute(metaJSON.attributes ,'model'),
                                projSpeed: parseFloat(getAttribute(metaJSON.attributes ,'speed')),
                                projMass: parseFloat(getAttribute(metaJSON.attributes ,'mass')),
                                projDelay : parseFloat(getAttribute(metaJSON.attributes ,'rate')),
                                projSize : parseFloat(getAttribute(metaJSON.attributes ,'size')),
                                power : parseFloat(getAttribute(metaJSON.attributes ,'power')),
                                durability : parseFloat(getAttribute(metaJSON.attributes ,'durability')),
                                dmg :  parseFloat(getAttribute(metaJSON.attributes ,'dmg')),
                                blastForce : parseFloat(getAttribute(metaJSON.attributes ,'blastForce')),
                                blastRadius : parseFloat(getAttribute(metaJSON.attributes ,'blastRadius'))

                            };

                assetLists.weapons.push(asset);

            }else if(type === 'motor'){

                if(categories.indexOf('motors')<0)
                    continue;

                const asset = { id: id, 
                                claim:false,
                                template_mint: edition.toString(), 
                                type: 3, 
                                class: getAttribute(metaJSON.attributes , 'class'), 
                                nitro: parseFloat(getAttribute(metaJSON.attributes , 'nitro')), 
                                a: parseFloat(getAttribute(metaJSON.attributes , 'a')), 
                                b: parseFloat(getAttribute(metaJSON.attributes , 'b')), 
                                c: parseFloat(getAttribute(metaJSON.attributes , 'c')), 
                                name: getAttribute(metaJSON.attributes , 'name'), 
                                motor: getAttribute(metaJSON.attributes, 'motor'), 
                                maxEngineForce: parseFloat(getAttribute(metaJSON.attributes,'power')), 
                                maxBreakingForce: parseFloat(getAttribute(metaJSON.attributes,'braking'))
                            };
                assetLists.motors.push(asset);
            }
        }
    }


    export async function getDamageMX(myAccount:string, GameKey :string, mainContract: string, icar:carAsset, update: number) {

        if (!icar.DMG) {

            const ID = icar.id;
            const seed = blake2bHex(ID).substr(0, 10);
            const programId = await new web3.PublicKey(mainContract);
            const gameKey = await new web3.PublicKey(GameKey);
            const dmgKey = await web3.PublicKey.createWithSeed(gameKey, seed, programId);
            const dmgAccount = await solanaConnection?.getAccountInfo(dmgKey);

            if(dmgAccount)
                icar.DMG = doDesera(CAR_DAMAGE_SCHEMA, dmgAccount.data);
        }

  
        /*
        if (update > 0) {
            this.dmgTimer = setTimeout(function () { self.getDamageMX(icar, update); }, 1000);
        }
        */
    }

    export async function getDamagesMX(assetLists:assetList, myAccount: string, GameKey: string, mainContract: string){

        for (let n = 0; n < assetLists.cars.length; n++) {

            if(!assetLists.cars[n].DMG)
                await getDamageMX(myAccount, GameKey, mainContract, assetLists.cars[n], 0);
        }
    }

    export async function getBalanceSolana( blockchaininfos:BlockchainInfos){

        if(!blockchaininfos.myAccount)
            return  {stl : '-', main : '-' };

        if(!solanaConnection)
            return  {stl : '-', main : '-' };

        if(!blockchaininfos.MintKey)
            return  {stl : '-', main : '-' };
        
        const pk = new web3.PublicKey(blockchaininfos.myAccount);
        let balance = null;
        try{
            balance = (await solanaConnection.getBalance(pk) / 1000000000.0).toFixed(2);
        }catch(e){
            return {stl : '-', main : '-' };
        }

        let steelBalance = '0.00';
        const mintKey = new web3.PublicKey(blockchaininfos.MintKey);
        //const e = await solanaConnection.getTokenAccountsByOwner(pk, {mint : mintKey});
        const TokenAccountAddress = await getAssociatedTokenAddressSync(mintKey, pk, false, blockchaininfos.TK);
        if(!TokenAccountAddress){
            return {stl : steelBalance, main : balance };
        }

        console.log(blockchaininfos.myAccount+' '+blockchaininfos.MintKey+' '+TokenAccountAddress?.toString());

        const mintAccount = await solanaConnection.getAccountInfo(TokenAccountAddress);
        if(!mintAccount){
             return {stl : steelBalance, main : balance };
        }
        const data = mintAccount.data;
        const amount = data.slice(64, 72).reverse();
        steelBalance = (readInt(amount) / 1000000).toFixed(2);
        
        //const accountInfo = this.web3.SPLToken.AccountLayout.decode(e.account.data);

        /*
        if(e.value.length>=1) {

          for(let v of e.value) {

              const account = v.account;
              const data = account.data;
              const mint = new web3.PublicKey(data.slice(0, 32));
              const mintAddr = mint.toString();

              if(mintAddr !== mintKey.toString())
                  continue;

              const owner = data.slice(32, 64);
              const amount = data.slice(64, 72).reverse();
              steelBalance = (readInt(amount) / 1000000).toFixed(2);
          }
        }
        */

        return {stl : steelBalance, main : balance };
    }

    export function getAssociatedTokenAddressSync(mint:web3.PublicKey ,owner:web3.PublicKey, allowOwnerOffCurve:Boolean = false, TK:ToKenDef)
     {
        /** Address of the SPL Token program */
        const TOKEN_PROGRAM_ID = new web3.PublicKey(TK.contract);
        /** Address of the SPL Associated Token Account program */
        const ASSOCIATED_TOKEN_PROGRAM_ID = new web3.PublicKey(TK.assoc);

        if (!allowOwnerOffCurve && !web3.PublicKey.isOnCurve(owner.toBuffer())) {
            return null;
        }
        const [address] = web3.PublicKey.findProgramAddressSync( [owner.toBuffer(), TOKEN_PROGRAM_ID.toBuffer(), mint.toBuffer()],ASSOCIATED_TOKEN_PROGRAM_ID );
        return address;
    }


    export async function buyNitroSolana(blockchaininfos:BlockchainInfos, n:number) {

        if((!blockchaininfos.myAccount)||(!blockchaininfos.nitros_seed)||(!blockchaininfos.MintKey)||(!blockchaininfos.MintKey))
            return;

        const pk = new web3.PublicKey(blockchaininfos.myAccount);

        const walletKey = pk;
        const gameKey = await new web3.PublicKey(blockchaininfos.GameKey);
        const programId = await new web3.PublicKey(blockchaininfos.mainContract);
        const mintKey = new web3.PublicKey(blockchaininfos.MintKey);
        const TOKEN_PROGRAM_ID = new web3.PublicKey(blockchaininfos.TK.contract);
        const nitroKey = await web3.PublicKey.createWithSeed(walletKey, blockchaininfos.nitros_seed , programId);
        
        let nitroAccount = await solanaConnection?.getAccountInfo(nitroKey);
        if(nitroAccount === null) {
            alert("no nitros account !");
            return;
        }
        
        const fromTokenAccount = await getAssociatedTokenAddressSync(mintKey, walletKey, false, blockchaininfos.TK);
        const destinationTokenAddr = await getAssociatedTokenAddressSync(mintKey, gameKey, false, blockchaininfos.TK);

        console.log('destinationTokenAddr '+destinationTokenAddr?.toString())

        const configKey = await web3.PublicKey.createWithSeed(gameKey, blockchaininfos.cfg_seed, programId);

        if((fromTokenAccount === null)||(destinationTokenAddr === null)||(configKey === null)){
            alert("no nitros account !");
            return;
        }

        const keys = [ {pubkey: fromTokenAccount, isSigner: false, isWritable: true},
                       {pubkey: destinationTokenAddr, isSigner: false, isWritable: true},
                       {pubkey: walletKey, isSigner: true, isWritable: false},
                       {pubkey: TOKEN_PROGRAM_ID, isSigner: false, isWritable: false},
                       {pubkey: mintKey, isSigner: false, isWritable: false},
                       {pubkey: configKey, isSigner: false, isWritable: false},
                       {pubkey: nitroKey, isSigner: false, isWritable: true}
                     ];
      
        const data = serialize({ struct : { nitros : 'u32'}}, {nitros : n});
        const nitrosSerBuf = new Uint8Array(data.length + 1);
        nitrosSerBuf[0] = 5;
        nitrosSerBuf.set(data, 1);
      
        const tx = new web3.Transaction().add(new web3.TransactionInstruction({programId: programId, keys : keys, data: Buffer.from(nitrosSerBuf.buffer)}));
        tx.feePayer = walletKey;
        tx.recentBlockhash  = (await solanaConnection?.getLatestBlockhash('finalized'))?.blockhash;

        doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos);

    }
    export async function get_config_mx(mainContract:string, GameKey:string, cfg_seed:string):Promise<GameConfig | null>{
        if(!solanaConnection){
            console.log('unable to get solana config');
            return null;
        }
        const programId = new web3.PublicKey(mainContract);
        const gameKey = new web3.PublicKey(GameKey);
        const configKey = await web3.PublicKey.createWithSeed(gameKey, cfg_seed, programId);

        try{
            console.log('config key :"'+configKey.toString()+'" contract "'+mainContract+'" GameKey "'+GameKey+'" cfg_seed "'+cfg_seed+'"');
            const cfgAccount = await solanaConnection.getAccountInfo(configKey);

            if(cfgAccount === null){
                console.warn('game config account not found !');
                return {repair_time : 1200, nitro_price : 5, steel_per_up: 15, per: 3};
            }else{
                return doDesera(CONFIG_SCHEMA, cfgAccount.data);
            }
        }catch(e:any){
            console.log('unable to connect solana network '+e.message);
            return null;
        }
    }


    export async function getUserInfosMX(myAccount:string, mainContract: string, nitros_seed:string){
    
        if (myAccount === null) {

           return null;
        }

        const walletKey = new web3.PublicKey(myAccount);
        const programId = await new web3.PublicKey(mainContract);

        try{
            const nitroKey = await web3.PublicKey.createWithSeed(walletKey,  nitros_seed , programId);
            let nitroAccount = await solanaConnection?.getAccountInfo(nitroKey);
            if((nitroAccount === null)||(nitroAccount === undefined)){
                return null;
            }else{
                const nitro = doDesera({struct : {nitros: 'u32', techs : 'u32', blueprints : 'u32', quest: 'u32'}}, nitroAccount.data);
                return {nitros : nitro.nitros, techBalance : (nitro.techs / 100), bluePrints : nitro.blueprints, quests : nitro.quests};
            }
        }catch(e){
            return {nitros : 0, techBalance : 0, bluePrints : 0, quests : 0};
        }
       

        
        
    }
    
    export async function getPrizesMX(myAccount: string, mainContract:string, nitros_seed:string){
        
        if (myAccount === null) {
            return 0;
        }

        const walletKey = new web3.PublicKey(myAccount);
        const programId = await new web3.PublicKey(mainContract);
        const nitroKey = await web3.PublicKey.createWithSeed(walletKey,  nitros_seed , programId);
        let nitroAccount = await solanaConnection?.getAccountInfo(nitroKey);

        if((nitroAccount === null)||(nitroAccount === undefined)){
            return 0;
        }

        const nitros = doDesera({struct : {nitros: 'u32', rewards : 'u32'}}, nitroAccount.data);
        if((nitros === null)||(nitros === undefined))
            return 0;

        return nitros.rewards;
    }

    export function getSignTxUrl(sessID:string, tx: web3.Transaction,  siteURL:string, phantomSession: string, sharedPK: Uint8Array, phantomPK: Uint8Array, sharedSk: Uint8Array){

      let nonce = new Uint8Array(24);

      for(let n=0; n<24; n++){
          nonce[n] = Math.random() * 255;
      }

      const pSession = JSON.parse(phantomSession);
      const serTx = tx.serialize({requireAllSignatures: false});
                  
      const pl = {
          "transaction": binary_to_base58(serTx), // serialized transaction, base58-encoded
          /* "sendOptions": "", // an optional Solana web3.js sendOptions object */
          "session": pSession.session, // token received from the connect method
      }

      const payload = new TextEncoder().encode(JSON.stringify(pl));

      const encrypted = nacl.box(payload, nonce, new Uint8Array(phantomPK), new Uint8Array(sharedSk));

      let baseURL = 'https://phantom.app/ul/v1/signAndSendTransaction?';
      baseURL += "dapp_encryption_public_key="+sharedPK;
      baseURL += "&nonce="+binary_to_base58(nonce);
      baseURL += "&redirect_link="+siteURL+'/api/phantomDoneTX?sessID='+sessID;
      baseURL += "&payload="+binary_to_base58(encrypted);

      return baseURL;

  }
    /*
    function getSignTxUrl(tx: web3.Transaction, sessID : string){

        if(!phantomPk)
            return null;

        if(!sharedSk)
            return null;

        let nonce = new Uint8Array(24);

        for(let n=0; n<24; n++){
            nonce[n] = Math.random() * 255;
        }

        const serTx = tx.serialize({requireAllSignatures: false});
                    
        const pl = {
            "transaction": binary_to_base58(serTx), // serialized transaction, base58-encoded
            // "sendOptions": "", // an optional Solana web3.js sendOptions object 
            "session": phantomSession, // token received from the connect method
        }
  
        const payload = new TextEncoder().encode(JSON.stringify(pl)); 
  
        const encrypted = nacl.box(payload, nonce, new Uint8Array(phantomPk), new Uint8Array(sharedSk));
  
        let baseURL = 'https://phantom.app/ul/v1/signAndSendTransaction?';
        baseURL += "dapp_encryption_public_key="+sharedPk;
        baseURL += "&nonce="+binary_to_base58(nonce);
        baseURL += "&redirect_link="+siteURL+'/doneTx?sessID='+sessID;
        baseURL += "&payload="+binary_to_base58(encrypted);

        return baseURL;

    }
    */
    
    declare const window: BackpackWindow;


    async function doTx(logType: number, TxData: web3.Transaction, sessID : string, infos: phantomAPP | null = null){

        if(!solanaConnection)
            return;
        
        switch(logType){
            case BACKPACK:
                
                const backpack = window.backpack;
                if(backpack){
                    const signature = await backpack.send(TxData, [], {}, solanaConnection);
                     await solanaConnection?.getSignatureStatus(signature.toString());
                }
            break;
            case PHANTOM:  
                const { signature } = await phantomProvider?.signAndSendTransaction(TxData);
                await solanaConnection?.getSignatureStatus(signature);
            break;
            case PHANTOMAPP:
                if(infos){
                    const url = getSignTxUrl( sessID, TxData, infos.siteURL, infos.phantomSession, infos.sharedPK, infos.phantomPK, infos.sharedSk);
                    if(url)
                        window.open(url);
                    else
                        alert('unable to get signed url');
                }
            break;

        }
    }

    export async function doSerTx(logType: number, serData: Uint8Array<ArrayBufferLike> , sessID : string, phantomInfos:phantomAPP | null = null){

        const TxData = web3.Transaction.from(serData);

        console.log('doSerTx:TxData.signatures');

        for(let f of TxData.signatures){
            console.log('signature key ' +f.publicKey.toString());
        }
        

        await doTx(logType, TxData, sessID, phantomInfos);
    }
    
    export async function initdmgSOL(infos:BlockchainInfos, carid : string, type: number) {

        const url = infos.gameServer.ssl ?'wss://':'ws://' + infos.gameServer.addr + ':' + infos.gameServer.port;

        const socket = new WebSocket(url);
        const ID = type === 3 ? carid: infos.myAccount+'-garagar-car';

        const promise = new Promise<Boolean>((resolveInner) =>{
            socket.onopen =  function (){

                const msg = {msg : "initdmg", data: {id : ID, network : infos.network, wallet: infos.myAccount}};
                socket.send(JSON.stringify(msg));

                socket.onmessage = async function (sockEv) {

                    if (typeof sockEv.data === 'string') {

                        let obj
                        try{
                            obj = JSON.parse(sockEv.data);
                        } catch(e) {
                            alert('unable to parse message ')
                            resolveInner(false);
                            return;
                        }

                        if(obj.msg === 'dmgtx'){
                            const etx = obj.data;
                            const serTx = base58_to_binary(etx);
                            const tx = web3.Transaction.from(serTx);
                            await doTx(infos.logType, tx, infos.sessID, infos.phantomInfos);
                            resolveInner(true);
                        }
                    }

                    socket.close();
                };
            }

            socket.onerror =  function (){
                resolveInner(false  );
            }

        });

        return promise;

        
    }

    async function findFreeSlot(blockchaininfos:BlockchainInfos, type: number){

        if((!blockchaininfos.myAccount)||(!solanaConnection))
            return -1;

        const pk = new web3.PublicKey(blockchaininfos.myAccount);
        const programId = await new web3.PublicKey(blockchaininfos.mainContract);
        const seed = blockchaininfos.garage_seed;
        const garageKey = await web3.PublicKey.createWithSeed(pk, seed , programId);
        const garageAccount = await solanaConnection.getAccountInfo(garageKey);
        if(garageAccount === null)
            return -1;

        const garageData = doDesera(METADATA_GARAGE_SCHEMA, garageAccount.data);

        if(type == 0){
            for(let n=0;n<garageData.tires.length;n++){
                if(garageData.tires[n].name[0] === 0)
                    return n;
            }

            return -1;
        }

        if(type == 1){
            for(let n=0;n<garageData.motors.length;n++){
                if(garageData.motors[n].name[0] === 0)
                    return n;
            }
            return -1;
        }

        if(type == 2){
            for(let n=0;n<garageData.batteries.length;n++){
                if(garageData.batteries[n].name[0] === 0)
                    return n;
            }
            return -1;
        }

        if(type == 3){
            for(let n=0;n<garageData.radars.length;n++){
                if(garageData.radars[n].name[0] === 0)
                    return n;
            }
            return -1;
        }

        if(type == 4){
            for(let n=0;n<garageData.weapons.length;n++){
                if(garageData.weapons[n].name[0] === 0)
                    return n;
            }
            return -1;
        }

        
        if(type == 2){
            for(let n=0;n<garageData.cars.length;n++){
                if(garageData.cars[n].name[0] === 0)
                    return n;
            }
            return -1;
        }

        return -1;
    }
    export function createStringBuffer(str:string, len = 16):Int8Array{
        const buff = new Int8Array(len);
      
        for(let n=0;n<str.length;n++){
            buff[n] = str.charCodeAt(n);
        }
      
        return buff;
      }
    export async function unmountAccessMX(blockchaininfos:BlockchainInfos, cat:string, name:string){

        if(!blockchaininfos.myAccount)
            return;

        if(!solanaConnection)
            return;

        const cats = ['tires','motors', 'batteries', 'radars',  'weapons', 'cars'];

        const assetType = cats.indexOf(cat);
        if(assetType<0) {
                console.log('wrong asset type')
            return
        }

        const destSlot = await findFreeSlot(blockchaininfos, assetType);
        if(destSlot<0)
        {
            alert('no free slot');
            return;
        }

        //const destSlot = 0;

        const data = serialize({ struct : { slot : 'u8', part_type : 'u8', name: {array: { type: 'i8' , len: 12}}}}, {slot : destSlot, part_type: assetType, name: createStringBuffer(name, 12) });

        const unmountSerBuf = new Uint8Array(data.length + 1);
        unmountSerBuf[0] = 7;
        unmountSerBuf.set(data, 1);

        const pk = new web3.PublicKey(blockchaininfos.myAccount);
        const gc = new web3.PublicKey(blockchaininfos.mainContract);
        const garageKey = await web3.PublicKey.createWithSeed(pk, blockchaininfos.garage_seed, gc);

        const keys = [ {pubkey: pk, isSigner: true, isWritable: false},
                        {pubkey: garageKey, isSigner: false, isWritable: true}];

        const tx = new web3.Transaction().add(new web3.TransactionInstruction({programId: gc, keys:keys, data: Buffer.from(unmountSerBuf.buffer)}));
        tx.feePayer = pk;
        tx.recentBlockhash  = (await solanaConnection?.getLatestBlockhash('finalized')).blockhash;

        await doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos);
    }

    export async function mountGarageMx(blockchaininfos:BlockchainInfos, slot:number, cat: string){

            if(!blockchaininfos.myAccount)
                return;

            if(!solanaConnection)
                return;

            const cats = ['tires','motors', 'batteries', 'radars',  'weapons'];

            const pid = cats.indexOf(cat);
            if(pid<0) {
                 console.log('wrong asset type')
                return
            }
        
            const pk = new web3.PublicKey(blockchaininfos.myAccount);

            //garage asset
            const mountSerBuf = new Uint8Array(3);
            mountSerBuf[0] = 8; //istr
            mountSerBuf[1] = slot; //slot
            mountSerBuf[2] = pid;
            
            const gc = new web3.PublicKey(blockchaininfos.mainContract);
            const garageKey = await web3.PublicKey.createWithSeed(pk, blockchaininfos.garage_seed, gc);

            const keys = [  {pubkey: pk, isSigner: true, isWritable: false},
                            {pubkey: garageKey, isSigner: false, isWritable: true}
                         ];

            const tx = new web3.Transaction().add(new web3.TransactionInstruction({programId: gc, keys:keys, data: Buffer.from(mountSerBuf.buffer)}));
            tx.feePayer = pk;
            tx.recentBlockhash  = (await solanaConnection.getLatestBlockhash('finalized')).blockhash;

            await doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos);
    }

      export async function mintGarageSlotSolana(blockchaininfos:BlockchainInfos, slot:number, slot_type:number) {
        
        if((!blockchaininfos.myAccount)||(!solanaConnection))
            return;
            
     
        let etx = null;
        let mtx = null;
        
        try{
            const r = await fetch("/api/mintSlot?slot="+slot+"&slot_type="+slot_type);
            const res = await r.json();

            if(res.error){
                console.log('error mint slot '+slot+' '+slot_type+' '+res.error);    
                return;
            }

            etx = res.tx;
            mtx = res.mtx;
        }catch(e:any){
            console.log('error proccessing action '+e.message);
            return;
        }

        if(!etx){
            console.log('unable to create tx');
            return;
        }
        
        if(mtx){
            const serTx = base58_to_binary(mtx);
            const tx = web3.Transaction.from(serTx);
            await doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos);
        }

        const serTx = base58_to_binary(etx);
        const tx = web3.Transaction.from(serTx);
        await doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos);
    }

    export async function mountAccessMX(blockchaininfos:BlockchainInfos, aid:string, type:number){

        if((!blockchaininfos.myAccount)||(!solanaConnection))
            return;
            
        
        const slot = await findFreeSlot(blockchaininfos, type);
        if(slot<0){
            console.log('no free slot');
            return;
        }
        
        //const slot = 0;

        let etx = null;
        
        try{
            const r = await fetch("/api/mountAsset?id="+aid+"&slot="+slot);
            const res = await r.json();

            if(res.error){
                console.log('error mounting asset '+aid+' '+res.error);    
                return;
            }

            etx = res.tx;
        }catch(e:any){
            console.log('error proccessing action '+e.message);
            return;
        }

        

        if(!etx){
            alert('invalid part');
            return;
        }
        
        const serTx = base58_to_binary(etx);
        const tx = web3.Transaction.from(serTx);

        await doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos);

    }
    
    async function createNitroAccount(blockchaininfos:BlockchainInfos){
        if(!blockchaininfos.myAccount)
            return;

        if(!blockchaininfos.nitros_seed)
            return;

        if(!solanaConnection)
            return;
        
        const walletKey = new web3.PublicKey(blockchaininfos.myAccount);
        const programId = await new web3.PublicKey(blockchaininfos.mainContract);
        const nitroKey = await web3.PublicKey.createWithSeed(walletKey, blockchaininfos.nitros_seed , programId);

        const ACC_SIZE = 16;
        const lamports = await solanaConnection.getMinimumBalanceForRentExemption(ACC_SIZE);
    
        const tx = new web3.Transaction().add(
            web3.SystemProgram.createAccountWithSeed({
                fromPubkey: walletKey, // funder
                newAccountPubkey: nitroKey,
                lamports: lamports, // 0.1 SOL
                space: ACC_SIZE,
                programId: programId,
                basePubkey: walletKey,
                seed: blockchaininfos.nitros_seed
                })
        );

        tx.recentBlockhash = (await solanaConnection.getLatestBlockhash('finalized')).blockhash;
        tx.feePayer = walletKey;

        doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos);

    }

    export async function initUserDataMX(blockchaininfos:BlockchainInfos){

        if(blockchaininfos.myAccount === null)
            return;

        if(blockchaininfos.nitros_seed === null)
            return;

        const walletKey = new web3.PublicKey(blockchaininfos.myAccount);
        const programId = await new web3.PublicKey(blockchaininfos.mainContract);
        const nitroKey = await web3.PublicKey.createWithSeed(walletKey,  blockchaininfos.nitros_seed , programId);
        let nitroAccount = await solanaConnection?.getAccountInfo(nitroKey);

        if(nitroAccount === null){
            await createNitroAccount(blockchaininfos);
        }
        
        return nitroAccount;
    }


    export async function modStatSolana(blockchaininfos:BlockchainInfos,  statMod:StatMod) {

        if(!blockchaininfos.MintKey)
            return;
        if(!blockchaininfos.myAccount)
            return;

        if(!solanaConnection)
            return;

        const seed = blockchaininfos.garage_seed;

        const pk = new web3.PublicKey(blockchaininfos.myAccount);

        const walletKey = pk;
        const gameKey = await new web3.PublicKey(blockchaininfos.GameKey);
        const programId = await new web3.PublicKey(blockchaininfos.mainContract);
        const mintKey = new web3.PublicKey(blockchaininfos.MintKey);
        const TOKEN_PROGRAM_ID = new web3.PublicKey(blockchaininfos.TK.contract);

        const garageKey = await web3.PublicKey.createWithSeed(pk, seed , programId);
        const garageAccount = await solanaConnection?.getAccountInfo(garageKey);
        if(garageAccount === null)
            return -1;

        const fromTokenAccount = await getAssociatedTokenAddressSync( mintKey, walletKey, false, blockchaininfos.TK);
        const destinationTokenAddr = await getAssociatedTokenAddressSync(mintKey, gameKey, false, blockchaininfos.TK);

        if(!destinationTokenAddr)
            return ;

        if(!fromTokenAccount)
            return ;        

        console.log('modStatSolana : destinationTokenAddr '+ destinationTokenAddr.toString());

        const configKey = await web3.PublicKey.createWithSeed(gameKey, blockchaininfos.cfg_seed, programId);

        const keys = [ {pubkey: fromTokenAccount, isSigner: false, isWritable: true},
                       {pubkey: destinationTokenAddr, isSigner: false, isWritable: true},
                       {pubkey: walletKey, isSigner: true, isWritable: false},
                       {pubkey: TOKEN_PROGRAM_ID, isSigner: false, isWritable: false},
                       {pubkey: mintKey, isSigner: false, isWritable: false},
                       {pubkey: pk, isSigner: true, isWritable: false},
                       {pubkey: garageKey, isSigner: false, isWritable: true},
                       {pubkey: configKey, isSigner: false, isWritable: false},
                       
                     ];
        let statid;
        const tx = new web3.Transaction();

        for(let k in statMod){
            switch(k){
                case 'compression':statid = 0;break;
                case 'damping':statid = 1;break;
                case 'stiffness':statid = 2;break;
                case 'friction':statid = 3;break;
                case 'force':statid = 4;break;
                default:alert('wrong state type'); return -1;break;
            }

            const data = serialize({ struct : { idx : 'u8', part_type : 'u8', statid : 'u8', num : 'i8' }}, {idx : 0, part_type : 0, statid : statid, num : statMod[k]});
            const modStatSerBuf = new Uint8Array(data.length + 1);
            modStatSerBuf[0] = 13;
            modStatSerBuf.set(data, 1);
            tx.add(new web3.TransactionInstruction({programId: programId, keys:keys, data: Buffer.from(modStatSerBuf.buffer)}));
        }
        
        tx.feePayer = walletKey;
        tx.recentBlockhash  = (await solanaConnection?.getLatestBlockhash('finalized')).blockhash;

        doTx(blockchaininfos.logType, tx, blockchaininfos.sessID, blockchaininfos.phantomInfos);

    }

